import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RolesComponent } from './roles.component';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { ComponentsModule } from 'projects/access-control/src/app/UI/components/component.module';
import { ActionsTableModule } from 'projects/access-control/src/app/UI/commons/actions-table/actions-table.module';
import { loadingSpinnerModule } from 'projects/access-control/src/app/UI/commons/loading-spinner/loading-spinner.module';
import { TooltipModule } from 'primeng/tooltip';
import { LayoutTableModule } from 'projects/access-control/src/app/UI/commons/layout-table/layout-table.module';
import { CommonsModule } from 'projects/access-control/src/app/UI/commons/commons.module';

@NgModule({
	declarations: [RolesComponent],
	exports: [RolesComponent],
	imports: [
		CommonModule,
		NgxDatatableModule,
		ComponentsModule,
		LayoutTableModule,
		CommonsModule,
		ActionsTableModule,
		loadingSpinnerModule,
		TooltipModule,
	],
})
export class RolesModule {}
